import { EyeIcon, EyeSlashIcon } from "@heroicons/react/24/outline";
import { useEffect, useState } from "react";

const Input = ({
  type = "text",
  label = "",
  value = "",
  setValue,
  error = "",
  setError = null,
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [customType, setCustomType] = useState(type);

  const focusHandler = () => {
    setIsFocused(true);
  };

  const blurHandler = (e) => {
    setIsFocused(e.target.value !== "");
  };

  const onChangeHandler = (e) => {
    setValue(e.target.value);
    if (setError) {
      setError();
    }
  };

  useEffect(() => {
    setIsFocused(value ? true : false);
  }, [value]);

  return (
    <div className="relative w-full">
      {label && (
        <label
          className={`absolute left-3 transition-all duration-300 bg-white px-1 text-gray-500
          ${isFocused ? `-top-2 text-sm` : "top-1/2 -translate-y-1/2"}`}
        >
          {label || ""}
        </label>
      )}
      <input
        type={customType}
        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
        value={value}
        onFocus={focusHandler}
        onBlur={blurHandler}
        onChange={onChangeHandler}
      />
      {error && (
        <span className="absolute top-full left-0 text-red-600 text-xs font-semibold">
          {error}
        </span>
      )}
      {type === "password" && (
        <>
          {customType === "text" && (
            <button
              type="button"
              className="absolute top-1/2 -translate-y-1/2 right-4"
              onClick={() => setCustomType("password")}
            >
              <EyeIcon className="size-5 text-gray-400" />
            </button>
          )}
          {customType === "password" && (
            <button
              type="button"
              className="absolute top-1/2 -translate-y-1/2 right-4"
              onClick={() => setCustomType("text")}
            >
              <EyeSlashIcon className="size-5 text-gray-400" />
            </button>
          )}
        </>
      )}
    </div>
  );
};

export default Input;
